<app-shared-dialog
  [title]="'inventory.edit_settings.title' | translate"
  [options]="{
    size: 'large',
    titleIcon: 'pen-cc',
    titleIconColor: 'primary',
    confirmText: 'common.save' | translate,
    cancelText: 'common.cancel' | translate,
    confirmButtonStyle: 'primary-btn',
    customConfirmButton: true
  }"
  (cancel)="cancel()"
>
  <form class="information-form" [formGroup]="form">
    <div class="form-content">

        <!-- // Packaging -->

      <!-- <div class="divider"></div> -->

      <div class="variants-container-title">
        {{ 'inventory.edit_settings.order_and_Stock' | translate }}
      </div>
      <div class="variants-container">
        <table class="variants-table">
            <thead>
              <tr class="row header">
                <th>
                  {{"inventory.product_edit_basic_infos.variant" | translate}}
                </th>
                <th>
                  {{"inventory.edit_settings.reorder_level" | translate}}
                </th>
                <th>{{"inventory.edit_settings.min_order_quantity" | translate}}</th>
                <th>{{"inventory.edit_settings.increment_quantity" | translate}}</th>
                <th>{{"inventory.edit_settings.max_order_quantity" | translate}}</th>
                <th>{{"inventory.edit_settings.oversell" | translate}}</th>
              </tr>
            </thead>
            <tbody [formGroup]="form">
                <ng-container *ngFor="let variant of data.variants; let i = index">
                  <tr class="row body">
                    <td>
                        <div class="variant-name">
                            <div class="tags-container">
                                <span class="tag" *ngFor="let value of variant.values">
                                    {{value}}
                                </span>
                            </div>
                        </div>
                    </td>   
                    <td>
                      <input (input)="sanitize($event)" type="number" [formControlName]="'reorder_point_' + variant.id">
                    </td> 
                    <td>
                        <input (input)="sanitize($event)" type="number" [formControlName]="'min_qte_' + variant.id">
                    </td>          
                    <td>
                        <input (input)="sanitize($event)" type="number" [formControlName]="'increment_' + variant.id">
                    </td>
                    <td>
                        <input (input)="sanitize($event)" type="number" [formControlName]="'max_qte_' + variant.id">
                    </td>
                    <td>
                        <mat-slide-toggle class="checkbox_table" [formControlName]="'can_be_sold_out_of_stock_' + variant.id" [checked]="form.get('can_be_sold_out_of_stock_' + variant.id)?.value"
                        ></mat-slide-toggle>
                    </td>
                  </tr>
                </ng-container>
            </tbody>
          </table>
      </div>
    </div>
  </form>
  <ui-button
    customConfirm
    *appHasPermission="{ module: 'product', action: 'edit' }"
    type="primary"
    [label]="'common.save' | translate"
    (click)="save()">
  </ui-button>
</app-shared-dialog>
